import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { take } from 'rxjs/operators/take';
import { Utils } from '../helpers';
import * as fromStore from '../store';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private store: Store<fromStore.State>) {}

  canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean>  {

    const allowedPermissions = (next.data['permissions'] || []) as Array<string>;
    const allowedRoles = (next.data['roles'] || []) as Array<string>;

    const authorized = this.store
      .select(fromStore.selectLoggedIn)
      .take(1);

    const permissions = this.store.select(fromStore.selectLoggedInUserPermissions)
      .map(p =>  Utils.hasOneOfOrNoRestriction(p, allowedPermissions) )
      .take(1);

    const roles = this.store.select(fromStore.selectLoggedInUserRoles)
      .map(r => Utils.hasOneOfOrNoRestriction(r, allowedRoles) )
      .take(1);

    return authorized.combineLatest(permissions, roles)
      .take(1)
      .map(([isAuthorized, hasPermission, hasRoles]) => {
        if (!isAuthorized) {
          this.store.dispatch(new fromStore.LoginRedirect());
          return false;
        }

        if (hasPermission && hasRoles) {
          return true;
        } else {
          this.store.dispatch(new fromStore.Go({ path: ['/'] }));
          return false;
        }
      });

  }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/auth.guard.ts